import React from 'react';
import {Collapse, Navbar, NavbarToggler, NavItem, NavLink} from 'reactstrap';
import {Link} from 'react-router-dom';
import './NavMenu.css';
import {withTranslation} from "react-i18next";
import i18next from "i18next";

class NavMenu extends React.Component {
    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.state = {
            isOpen: false,
            lang: ""
        };
    }

    componentDidMount() {
        this.setLangButton();
    }

    toggle() {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }

    setLangButton = () => {
        const lng1 = i18next.languages[0];
        if (lng1.toLowerCase() === "ru" || lng1.toLowerCase() === 'ru-ru')
            this.setState({lang: 'en'})
        else if (lng1.toLowerCase() === "en" || lng1.toLowerCase() === 'en-us')
            this.setState({lang: 'ru'});
        else
            this.setState({lang: 'ru'});
    }

    changeLang = (e) => {
        e.preventDefault();
        i18next.changeLanguage(this.state.lang, (err, t) => {
            if (err) return console.log('something went wrong loading', err);
            t('key'); // -> same as i18next.t
        });
        if (this.state.lang === 'en') {
            this.setState({lang: 'ru'})
        } else if (this.state.lang === 'ru') {
            this.setState({lang: 'en'})
        }
    }

    render() {
        const {t} = this.props;
        return (
            <header>
                <div className="logo border-bottom">
                    <div>
                        <NavLink className='text-white logo-link' tag={Link} to="/">
                            <div id='ea-logo'>ELEONORA AMOSOVA</div>
                            <div id='moscow-logo'>MOSCOW</div>
                        </NavLink>
                    </div>
                </div>
                <Navbar className="navbar-expand-lg navbar-toggler navbar-dark"
                        dark>
                    <div className='lang-btn'>
                        <ul className='navbar-nav flex-grow-0 '>
                            <NavItem>
                                <NavLink href="#" onClick={this.changeLang} className="text-white-50"
                                         to="/contacts">{this.state.lang}</NavLink>
                            </NavItem>
                        </ul>
                    </div>
                    <NavbarToggler onClick={this.toggle} className="mr-2"/>
                    <Collapse className="d-lg-inline-flex flex-lg-row-reverse" isOpen={this.state.isOpen}
                              navbar>
                        <ul className="navbar-nav flex-grow-0 ">
                            <NavItem>
                                <NavLink tag={Link} className="text-white-50"
                                         to="/collections">{t('navmenu.collections')}</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink tag={Link} className="text-white-50" to="/show">{t('navmenu.show')}</NavLink>
                            </NavItem>
                            {t('navmenu.atelier') !== "" ?
                                <NavItem>
                                    <NavLink tag={Link} className="text-white-50"
                                             to="/atelier">{t('navmenu.atelier')}</NavLink>
                                </NavItem>
                                : ""}
                            <NavItem>
                                <NavLink tag={Link} className="text-white-50"
                                         to="/designer">{t('navmenu.designer')}</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink tag={Link} className="text-white-50"
                                         to="/contacts">{t('navmenu.contacts')}</NavLink>
                            </NavItem>
                        </ul>
                    </Collapse>
                </Navbar>
            </header>
        );
    }
}

const Page = withTranslation()(NavMenu);
export default Page;


// WEBPACK FOOTER //
// ./src/components/NavMenu.js